import {FC, ReactNode} from 'react';

export type TabProps = {
    label: string;
    isEnabled?: boolean;
    children: ReactNode;
}

const Tab: FC<TabProps> = ({label, isEnabled = true, children}) => {
    return (
        <>
            {children}
        </>
    );
};

export default Tab;
